 /* Change this file to get your personal Porfolio */

// Website related settings
 const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Jama's Portfolio",
  description:  
  "Looking for a position in the Internet space where I can use my past experience, teamwork skills, and Internet-based competencies to make a difference. i have a strong ability to work within your existing designs as well as the creativity and vision to bring new design ideas to the table.",
  og: {
    title: "Jama's Portfolio",
    type: "website",
    url: "https://jsxcode.com/reactapps/portfolio/",
  },
};

//Home Page  //logo_name= sixiixa pageka
const greeting = {
  title: "Jama Hassan",
  logo_name: "JamaHassan",
  //nickname: "",
  subTitle:
    "Principal software engineer, focused on modern web technologies with 14 Years Extensive experience building and maintaining reusable components.   Multiple years of experience in all stages of web and software development lifecycle. ",
  resumeLink:
    "https://jsxcode.com/re.html",
  My_Ebook: "https://jsxcode.com",
  githubProfile: "https://jsxcode.com/reactapps/mainapps/",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Jama-Hassan",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/2gole/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  
  {
    name: "Gmail",
    link: "mailto:hkaafi@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  /*
{
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },

  {
    name: "X-Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/laymanbrother.19/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/layman_brother/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },*/
];


// Skills
/*
const skills = {
  
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ], 
    },
    */
    const skills = {
      data: [

        // Bilowkaga //
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ I am a software engineer / Focused Modern Web Technologies Specific programming languages to create engaging user interface.",
        "⚡ Developing mobile applications using React Native, Flutter and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express, Java, PHP & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#0074bd",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#484c89",
          },
        },

      
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },

        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        /*
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        }, */
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    // Bilowkaga //
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // Bilowkaga //
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Creating the flow of application functionalities to optimize user experience",
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
       
      ],
      softwareSkills: [
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },

        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#1abcfe",
          },
        },

        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
     
       /*
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          }, 
        },*/
      ],   
    },

// Sida laysugu bedbedelo pages-ka -kani waa kii ugu horeeye hadana waa ka ugu danbeeya//
 // Bilowkaga //
{
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },

/*
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
       
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },  */
      ], 
    },

    
  ],
};
// Dhamaadka (Home-page-ka) 


// Education Page
const competitiveSites = {
  competitiveSites: [
   
  
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com",
    },

    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com",
    },
    /*
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
    */
  ],
};

const degrees = {
  degrees: [
    {
      title: "Tkk University of Technology",
      subtitle: "BS. in Computer Science",
      logo_path: "HUOFTeCH.png",
      alt_name: "",
      duration: "1995 - 1999",
      descriptions: [
        "⚡ I have studied software engineering courses on Full Stack Development, Cloud Computing and Algorithms, Data Science.",
        "",
        
      ],
      website_link: "http://jsxcode.com",
    },
    {
      title: "SJSU",
      subtitle: "Graduate Student (Advanced) M.S. in Computer Science",
      logo_path: "sju-logo.png",
      alt_name: "",
      duration: "2025 - continuing",
      descriptions: [
        "⚡ I have done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
        "⚡ Apart from this, I have taken variety of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc. ",
      ],
      website_link: "https://www.sjsu.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    /*
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    }, */
    {
      title: "Fullstack Development",
      subtitle: "- React,Node.js,Express,",
      logo_path: "coursera_logo.png",
      certificate_link:
        "",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },

    {
      title: "AWS",
      subtitle: "",
      logo_path: "amazon_logo.png",
      certificate_link:
        "",
      alt_name: "Amazon",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
/*

    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    */
   
    /*
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    */
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Leadership and Research",
  description:
    "I have worked with many evolving companies as Software Engineer, UI Developer and Software Architect. I Keep up with competition and work with a high-performing teams for Web Application Development.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
 {
      title: "I am a Software Engineer / Focused Modern Web Technologies Specific programming languages.   Front-end web development is all about creativity and creative problem-solving. As a UI developer, I have the skills to build customized websites to create the best possible user experience.",
      subtitle: "FullStack Developer",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.jsxcode.com",
      alt_name: "Jsxcode",
      color_code: "#2A73CC",
    },


        {
          title: "FullStack Engineer",
          company: "UPS CAPITAL.",
          company_url: "https://www.ups.com/us/en/",
          logo_path: "upsCapital.png",
          duration: "March 2023 - Present",
          location: "San Francisco, CA, USA",
          description:
            "Built and maintained cross-platform features using React Native for iOS and Android. Enhanced performance of React Native applications through code optimization, caching, and lazy loading. Work with back-end developers to integrate UI components with APIs and databases Node.js frameworks and libraries (Express.js, Next.JS).Develop React UI components and built, tested, and Integrate UI with large backend applications. Integrated React Native front-end with backend services using Node.js, Express, and RESTful APIs.  ",
            
          color: "#000000",
        },
        {
          title: "Senior Software Engineer",
          company: "Bed Bath & Beond",
          company_url: "https://www.bedbathandbeyond.com/",
          logo_path: "BedBath-Beyond.png",
          duration: "May 2022 - Feb 2023",
          location: "San Francisco, California",
          description:
            "Develop React.Js UI components and tested with Jest, built and implemented user interface applications. Built cross-platform mobile features for iOS and Android using React Native. Created reusable React Native components for product listing, cart, and checkout screens. Developed new product features, designed dynamic user interface and created mockups for new applications. Participate in daily/weekly meeting with business and daily scrum call checking in with other team members throughout the day with questions and updates.  Integrated REST APIs with React Native for product and order management.",
          color: "#0879bf",
        },
        {
          title: "Tech Lead",
          company: "United Airline HQ",
          company_url: "https://www.United.com/en/",
          logo_path: "united-airlines-logo.png",
          duration: "October 2021 - April 2022",
          location: "San Francisco, Remote",
          description:
            "Developed and maintained React Native mobile applications for United Airlines operations and customer services. • Develop UI components and built, tested, and implemented user interface applications. Assisted with product development projects. Integrated UI with large backend applications. Implemented modules into Node JS to integrate with designs and requirements. Implemented various screens for the front end using React.Js and used various predefined components from NPM (Node Package Manager) and Redux library. Improved app performance and responsiveness by optimizing React Native components. Used React.js and React Native to create templates for faster compilation and developing reusable components. Integrated these components with back-end systems, APIs, and databases using Node.js frameworks (Express.js, Next.js). Used Redux and Context API for state management in React Native. Successfully utilized TypeScript, Webpack, and Babel to enhance code quality, ensure cross-browser compatibility, and optimize build processes for scalable applications. Integrated modern tools like Redux, TypeScript, and PostCSS to improve performance, maintainability, and overall user experience.",
          color: "#9b1578",
        },
        {
          title: "UI Lead Senior Software Engineer",
          company: "WWWCODES.COM.",
          company_url: "https://wwwcodes.com",
          logo_path: "wwwcodeslogo11.png",
          duration: "March 2016 - October 2021 ",
          location: "San Francisco, California",
          description:
            "World Wide Web Codes (wwwcodes.com) is a cloud-based web development platform and virtual web coding factory that customizes and creates modern web application templates for a variety of customers. Work closely with UX team to implement new features with visual elements that users see and interact with in a web application. HTML, XHTML, Ajax, JavaScript, and CSS. Designed and implemented custom React Native modules to enhance app functionality and user experience. Developed new product features, designed dynamic user interface, and created mockups for new applications. Designed graphics for web Programming: JavaScript, Next.js, HTML, CSS, PHP, MySQL, PL/SQL, Mango DB and UNIX/ Shell.  Implemented real-time updates and background sync features using React Native libraries.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Leadership",
      experiences: [
        {
          title: "Tech Lead",
          company: "United Airlines.",
          company_url: "https://www.United.com/en/",
          logo_path: "united-airlines-logo.png",
          duration: "October 2021 - April 2022",
          location: "San Francisco, USA",
          description:
            "Lead team of 8 in development, testing, debugging, and maintenance of dynamicuser interface, and created mockups for new applications. Daily meeting, Checking in with other team members throughout the day with Questions and updates. Interact with team to clarify functional requirements & provide daily updates.",
          color: "#000000",
        },
        /*
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        }, */
      ],
    }, 


    {
      title: "Research",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2022 - April 2025",
          location: "Hyderabad, Telangana",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2022 - May 2025",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2014 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },

/*

        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        }, */
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Full Stack projects and web applications using cloud infrastructure.",
    avatar_image_path: "projects_image.svg",
   
};

 
const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Projects and Articles.",
  avatar_image_path: "projects_image.svg",
  
};  

const publications = {
  data: [
    {
      id: "Amazon Clone",
      name: "Amazon Clone",
      createdAt: "2021-05-27T00:00:00Z",
      description: 
       " This is basically a clone of the well-known e-commerce website Amazon. It uses fiberbase for user authentication.",
      url: "https://jsxcode.com/reactapps/amazon-firestore/",
    },
    
    {
      id: "A Whack a Mole Game",
      name: "A Whack a Mole Game",
      createdAt: "2022-07-08T00:00:00Z",
      description: "I Created a Whaak a Mole Game with React.js Using Hooks and Router ",
      url: "https://jsxcode.com/jsxcode/reactapps/molegame/",
    },
    
    {
      id: "React Responsive WebApp",
      name: "React Responsive WebApp",
      createdAt: "2023-09-01T00:00:00Z",
      description: "React Responsive Website Using Hooks and Router with Reusable Components",
      url: "https://jsxcode.com/reactapps/react-mainapps/#/",
    },

    {
      id: "Responsive Website with JS + HTML + CSS",
      name: "Responsive Website",
      createdAt: "2020-10-20T00:00:00Z",
      description: "Mobile Friendly and Responsive Website. ",
      url: "https://jsxcode.com/code",
    },

  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
  title: "Contact Me",
  //avatar_image_path: "aprogrammer.svg",
   profile_image_path: "aprogrammer.svg",
  description:
      "Every Software developer inevitably runs into situations where they need to make visual.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey and share some technical knowledge.",
    link: "https://jsxcode.com/jsxcode/tech-stack.html",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Bayside Dr, San Francisco, CA, USA 94130",
    locality: "San Francisco",
    country: "USA",
    region: "California",
    postalCode: "94130",
    streetAddress: "Bayside Dr ",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Bayside+Dr,+San+Francisco,+CA+94130/@37.8297438,-122.378963,452m/data=!3m2!1e3!4b1!4m6!3m5!1s0x808581c9a87e72c7:0x8557d531810dda04!8m2!3d37.8297438!4d-122.3763934!16s%2Fg%2F1tltmlqt?entry=ttu&g_ep=EgoyMDI2MDUxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
